var _rect, _rect2, _g, _rect3, _rect4, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanelTypeFour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "710px",
    height: "672px",
    viewBox: "0 0 710 672",
    enableBackground: "new 0 0 710 672",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 75.6,
    y: 75.9,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 560.4,
    height: 389
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 98.6,
    y: 99,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 514.2,
    height: 342.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 22.6,
    y: 14,
    fill: "#FFFFFF",
    width: 667.2,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.6,
    y: 14,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.7037,
    width: 667.2,
    height: 13
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 685.2,
    y: 12,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 12,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9532,
    strokeMiterlimit: 10,
    d: "M138.9,653.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V31.9c0,0,4.9,0,15.1,0s15.1,0,15.1,0V653.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M108.7,654.5c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V31.9h34.5V654.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M74.2,654.5c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V31.9h34.5V654.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9532,
    strokeMiterlimit: 10,
    d: "M571,654.5c0,0,7.7,8.2,15.6,8.3 c7.9,0.1,14.6-7.3,14.6-7.3V31.9c0,0-4.9,0-15.1,0c-10.2,0-15.1,0-15.1,0V654.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M601.2,655.5c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V31.9h-34.5V655.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M635.7,655.5c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V31.9h-34.5V655.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M283.7,655.5c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V31.9h34.5V655.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M249.2,655.5c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V31.9h34.5V655.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M318.2,655.5c-4.6-2.4-8.1,0.5-8.1,0.5 s-5.2,6.8-13.2,6.8s-13.2-7.3-13.2-7.3V31.9h34.5V655.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M426.3,655.5c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V31.9h-34.5V655.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M460.8,655.5c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V31.9h-34.5V655.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M391.8,655.5c4.6-2.4,8.1,0.5,8.1,0.5 s5.2,6.8,13.2,6.8s13.2-7.3,13.2-7.3V31.9h-34.5V655.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelTypeFour);
export default __webpack_public_path__ + "static/media/panel_type_four.8ea28cb765c0549893c1a8ff7fc340e8.svg";
export { ForwardRef as ReactComponent };